module.exports = __webpack_public_path__ + "assets/icon-hide-black.4ce02bb4.svg";